import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-discussion-board',
  templateUrl: './feature-discussion-board.component.html',
  styleUrls: ['./feature-discussion-board.component.css']
})
export class FeatureDiscussionBoardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
